const V2_TO_V1: Record<string, string> = {
  id: "_id",
  type: "_type",
  name: "_name",
};

export default function (params: Record<string, any>, prefix: string) {
  const requiredObject: Record<string, any> = {};
  const keys = Object.keys(params);
  if (keys.length) {
    keys.forEach((key: string) => {
      if (V2_TO_V1?.[key]) {
        requiredObject[`${prefix}${V2_TO_V1[key]}`] = params[key];
      } else requiredObject[key] = params[key];
    });

    return requiredObject;
  }
  return params;
}
